import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export function useDeleteAdviceFoliar() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async (id: string) => {
			try {
				await api.delete(`/advices/foliar-application/delete/${id}`, {
					params: { forBinding },
				});
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar recomendação de foliares');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['foliar'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao deletar correção:',
				getApiErrorMessage(error, 'Erro ao deletar recomendação de foliares')
			),
	});
}
